export default {
  title: {
    changeMobileRequest: 'Change Mobile Request',
    bindMobileRequest: 'Mobile Connect Request'
  },
  label: {
    currentMobile: 'Current Mobile',
    newMobile: 'New Mobile',
    pleaseEnterMobile: 'Mainland China Mobile Number',
    captcha: 'Captcha',
    smsCode: 'SMS Code',
    generate: 'Get Code Now'
  },
  message: {
    mobileIsInvalid: 'Invalid number. This service is still updating for non Mainland China users.',
    success: 'Change mobile successfully, now you can login with the mobile.'
  }
}
